import { Route, Routes } from "react-router-dom";

import EducationTraining from "./Values/Values";
import ValueAwareness from "./Values/ValueAwareness";
import ValueEducation from "./Values/ValueEducation";
import ValueCultivation from "./Values/ValueCultivation";

function ValuesApp() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<EducationTraining />} />
        <Route path="valuesawareness" element={<ValueAwareness />} />
        <Route path="valueseducation" element={<ValueEducation />} />
        <Route path="valuescultivation" element={<ValueCultivation />} />
      </Routes>
    </div>
  );
}

export default ValuesApp;
